import { render } from "./RadioField.vue?vue&type=template&id=b43d54a6"
import script from "./RadioField.vue?vue&type=script&lang=js"
export * from "./RadioField.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__